import React from 'react'

const NewEditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 11 10" fill="none">
      <path d="M6.42649 1.64823L8.43555 3.66711L3.35006 8.77752L1.34213 6.75863L6.42649 1.64823ZM9.96004 1.16132L9.06408 0.260967C8.71782 -0.0869889 8.15557 -0.0869889 7.80813 0.260967L6.94988 1.12342L8.95895 3.14232L9.96004 2.13632C10.2286 1.86643 10.2286 1.4312 9.96004 1.16132ZM0.290747 9.59634C0.254185 9.76169 0.40275 9.90986 0.567318 9.86965L2.80608 9.32417L0.798158 7.30529L0.290747 9.59634Z" fill="currentColor"/>
    </svg>
  )
}

export default NewEditIcon
